<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <div class="mb-3">
        <b>ที่อยู่สำหรับรับบริการ</b>
      </div>
      <section>
        <div>
          <label>
            <input type="radio" name="radioAddress" value="user-place-address" v-model="radioAddress">
            ใช้ที่อยู่ที่เลือก
          </label>
        </div>
        <div>
          <label>
            <input type="radio" name="radioAddress" value="new-address" v-model="radioAddress"> ใช้ที่อยู่ใหม่
          </label>
        </div>
        <div class="border shadow-sm rounded mt-2 p-2 text-small" v-if="userPlace && radioAddress === 'user-place-address'">
          <div><label>{{ userPlace.place_name }}</label></div>
          <div>{{ userPlace.place_size.name_th }}</div>
          <div>
            <span>ที่อยู่: {{ userPlace.address }}</span>
            <span>อำเภอ/เขต: {{ userPlace.district.name_th }}</span>
            <span>จังหวัด: {{ userPlace.address_province.name_th }}</span>
          </div>
        </div>
        <div class="mt-2" v-else-if="radioAddress === 'new-address'">
          <!-- Address -->
          <section>
            <label for="address">{{ $t('message.booking.contact_step.address') }} - {{
              $t('message.booking.contact_step.address_remark') }}</label>
            <input type="text"
                   class="form-control input-jumbo"
                   :class="{'form-alert': errors.has('address')}"
                   id="address"
                   name="address"
                   ref="address"
                   v-model="submitData.building_address"
                   v-validate="'required'">
            <div class="mt-1 text-remark -status-alert" v-if="errors.has('address')">
              {{ $t('message.required_field') }}
            </div>
          </section>
          <!-- Province -->
          <section class="pt-3">
            <label for="addressProvince">{{ $t('message.business.contact_province') }}</label>
            <div class="select-jumbo">
              <select v-model="submitData.address_province_id"
                      :class="{'form-alert': errors.has('addressProvince')}"
                      v-validate="'required'"
                      id="addressProvince"
                      name="addressProvince">
                <option :value="null">{{ $t('message.booking.contact_step.set_province') }}</option>
                <option :value="addressProvince.id" v-for="addressProvince, index in sortedProvinces">
                  {{ addressProvince | multiLangName }}
                </option>
              </select>
            </div>
            <div class="mt-1 text-remark -status-alert" v-if="errors.has('addressProvince')">
              {{ $t('message.required_field') }}
            </div>
          </section>

          <!-- Districts and sub-districts -->
          <div class="row pt-3 no-gutters">
            <div class="col-6 pr-1">
              <label for="district">{{ $t('message.booking.contact_step.district') }}</label>
              <div class="select-jumbo">
                <select v-model="submitData.district_id"
                        :class="{'form-alert': errors.has('district')}"
                        v-validate="'required'"
                        id="district"
                        name="district">
                  <option :value="null">{{ $t('message.booking.contact_step.set_district') }}</option>
                  <option :value="district.id" v-for="district, index in sortedDistricts">
                    {{ district | multiLangName }}
                  </option>
                </select>
              </div>
              <div class="mt-1 text-remark -status-alert" v-if="errors.has('district')">
                {{ $t('message.required_field') }}
              </div>
            </div>
            <div class="col-6 pl-1">
              <label for="sub-district">{{ $t('message.booking.contact_step.sub_district2') }}</label>
              <div class="select-jumbo">
                <select v-model="submitData.sub_district_id" id="sub-district">
                  <option :value="null">{{ $t('message.booking.contact_step.set_sub_district') }}</option>
                  <option :value="subDistrcict.id" v-for="subDistrcict, index in sortedSubDistricts">
                    {{ subDistrcict | multiLangName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr>

      <!-- Attach photos -->
      <div>
        <h4 class="pb-2">
          <i class="fal fa-images fa-lg"></i>&nbsp;&nbsp;{{
          $t('message.service_request.big_cleaning_attach_photos') }}
          <span class="text-danger" v-if="errorNoUploadPhoto">
            <i class="fa fa-exclamation-circle"></i>
          </span>
        </h4>
        <div class="text-remark mb-2">
          <i class="fas fa-circle fa-sm -status-pending"></i>&nbsp;{{ (bookingData && bookingData.service_request && bookingData.service_request.service_id === 49) ? $t('message.service_request.upholstery_cleaning_attach_photos_remark') : $t('message.service_request.big_cleaning_attach_photos_remark') }}
        </div>
        <vue-dropzone ref="vueDropzone"
                      id="dropzone"
                      class="dropzone-dashed"
                      :options="dropzoneOptions"
                      @vdropzone-file-added="clearFileUploadError"/>
        <div class="mt-2 text-remark -status-alert" v-if="errorNoUploadPhoto">
          {{ $t('message.required_photo_attachment') }}
        </div>
      </div>

      <!-- Remark -->
      <div class="pt-4">
        <h4 class="pb-2">{{ $t('message.service_request.big_cleaning_remark') }}</h4>
        <textarea rows="3"
                  ref="remark"
                  id="remark"
                  :placeholder="$i18n.t('message.service_request.big_cleaning_remark_placeholder')"
                  class="form-control textarea-jumbo"
                  v-model="submitData.remark"/>
      </div>

      <hr>

      <div class="text-small">
        <h4 class="pb-2 text-orange">{{ $t('message.service_request.service_request_condition_title') }}</h4>
        <ul class="list-unstyled">
          <li class="pb-3">
            <i class="fas fa-circle fa-xs -status-pending"></i>&nbsp;{{
            $t('message.service_request.service_request_remark01') }}
          </li>
          <li class="pb-3">
            <i class="fas fa-circle fa-xs -status-pending"></i>&nbsp;{{
            $t('message.service_request.service_request_remark02') }}
          </li>
          <li>
            <i class="fas fa-circle fa-xs -status-pending"></i>&nbsp;{{
            $t('message.service_request.service_request_remark03') }}
          </li>
        </ul>
      </div>

      <div class="form-group pt-4" v-if="!saveSuccess">
        <button class="btn btn-block btn-info" :disabled="isSubmitting" @click="submit()">
          {{ isSubmitting ? 'กำลังส่งคำขอ...' : 'ส่งคำขอ' }}
        </button>
        <button class="btn btn-block btn btn-outline-secondary" @click="cancelRequest()">ยกเลิก</button>
      </div>

      <div class="text-center mt-4" v-else>
        <h3>
          <i class="fas fa-check-circle -status-accepted"></i> บันทึกข้อมูลสำเร็จ
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import axios from 'axios'
  import vue2Dropzone from 'vue2-dropzone'

  export default {
    props: {
      message: Object
    },
    components: {
      vueDropzone: vue2Dropzone
    },
    data () {
      return {
        radioAddress: 'user-place-address',
        userPlace: null,
        submitData: {
          building_address: null,
          address_province_id: null,
          district_id: null,
          sub_district_id: null,
          remark: null
        },
        sortBy: 'name_th',
        isSubmitting: false,
        saveSuccess: false,
        dropzoneOptions: {
          acceptedFiles: 'image/*',
          url: 'https://beneat.co',
          thumbnailWidth: 160,
          thumbnailHeight: 160,
          maxFilesize: 5,
          dictDefaultMessage: `<i class="fal fa-cloud-upload"></i> ${this.$i18n.t('message.button.upload_photos')}`,
          headers: {'Content-Type': 'multipart/form-data'},
          addRemoveLinks: true,
          autoProcessQueue: false,
          maxFiles: 20
        },
        errorNoUploadPhoto: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      }),
      ...mapState('chatBooking', ['messages', 'bookingData']),
      ...mapState('addressProvince', ['addressProvinces', 'districts', 'subDistricts']),
      sortedProvinces () {
        return this._.orderBy(this.addressProvinces, [this.sortBy], ['asc'])
      },
      sortedDistricts () {
        return this._.orderBy(this.districts, [this.sortBy], ['asc'])
      },
      sortedSubDistricts () {
        return this._.orderBy(this.subDistricts, [this.sortBy], ['asc'])
      }
    },
    watch: {
      'submitData.address_province_id': function (newVal, oldVal) {
        this.fetchDistricts(this.submitData.address_province_id)
      },
      'submitData.district_id': function (newVal, oldVal) {
        this.fetchSubDistricts(this.submitData.district_id)
      }
    },
    methods: {
      async fetchUserPlace () {
        const userPlaceId = this.bookingData.user_place_id
        const url = `/users-places/${userPlaceId}`
        const {data} = await axios.get(url)
        this.userPlace = data
      },
      sendMessage (action) {
        const message = {
          sender_type: 'user',
          type: 'text',
          label: action.label,
          text: action.text,
          data: action.data
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      removeBookingDataServiceRequest () {
        // Remove service_request from bookingData
        this.$store.commit('chatBooking/REMOVE_BOOKING_DATA', 'service_request')
      },
      cancelRequest () {
        this.removeBookingDataServiceRequest()
        const action = {
          label: 'cancel-service-request',
          text: 'ยกเลิก'
        }
        this.sendMessage(action)
      },
      submit () {
        this.errorNoUploadPhoto = (this.$refs.vueDropzone.getQueuedFiles().length === 0)
        if (!this.errorNoUploadPhoto) {
          if (this.radioAddress === 'new-address') {
            this.$validator.validate().then(valid => {
              if (valid) {
                this.displayConfirmDialog()
              }
            })
          } else {
            this.displayConfirmDialog()
          }
        }
      },
      displayConfirmDialog () {
        this.$swal({
          title: this.$i18n.t('message.service_request.service_request_confirm_dialog_title'),
          text: this.$i18n.t('message.service_request.service_request_confirm_dialog_message'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.button.confirm'),
          cancelButtonText: this.$i18n.t('message.button.cancel')
        }).then(() => {
          this.addServiceRequest()
        })
      },
      addServiceRequest () {
        const serviceRequest = this.bookingData.service_request
        let serviceDate = `${serviceRequest.service_date} ${serviceRequest.service_time}`
        let buildingAddress = this.submitData.building_address
        let addressProvinceId = this.submitData.address_province_id
        let districtId = this.submitData.district_id
        let subDistrictId = (this.submitData.sub_district_id) ? this.submitData.sub_district_id : null
        if (this.radioAddress === 'user-place-address') {
          buildingAddress = this.userPlace.address
          addressProvinceId = this.userPlace.address_province_id
          districtId = this.userPlace.district_id
          subDistrictId = (this.userPlace.sub_district_id) ? this.userPlace.sub_district_id : null
        }
        const buildingTypeId = (serviceRequest.building_type_id) ? serviceRequest.building_type_id : 0
        let formData = new FormData()
        formData.append('user_id', this.user.id)
        formData.append('service_id', serviceRequest.service_id)
        formData.append('service_date', serviceDate)
        formData.append('service_request_purpose_id', serviceRequest.service_request_purpose_id)
        formData.append('building_type_id', buildingTypeId)
        formData.append('building_size', serviceRequest.building_size)
        formData.append('building_address', buildingAddress)
        formData.append('address_province_id', addressProvinceId)
        formData.append('district_id', districtId)
        formData.append('remark', this.submitData.remark)
        formData.append('language', this.$i18n.locale)
        formData.append('platform', 'chat')
        formData.append('add_order', true)

        if (this.$route.query.ref) {
          formData.append('referral_code', this.$route.query.ref)
        }

        if (this.submitData.remark) {
          formData.append('remark', this.submitData.remark)
        }

        if (subDistrictId) {
          formData.append('sub_district_id', subDistrictId)
        }

        if (this.bookingData.user_place_id) {
          formData.append('user_place_id', this.bookingData.user_place_id)
        }

        // Prepare file uploads
        const queueFiles = this.$refs.vueDropzone.getQueuedFiles()
        for (let key in queueFiles) {
          formData.append('upload_image[]', queueFiles[key])
        }

        // Display the key/value pairs
        for (let pair of formData.entries()) {
          console.log(pair[0] + ', ' + pair[1])
        }

        this.isSubmitting = true
        let url = '/service-requests'
        axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then((res) => {
            this.isSubmitting = false
            this.saveSuccess = true
            const response = res.data
            if (!response.error) {
              this.removeBookingDataServiceRequest()
              const message = {
                sender_type: 'user',
                type: 'text',
                label: 'success-service-request',
                text: 'ส่งคำขอประเมินราคา และวันเข้าให้บริการสำเร็จ'
              }
              this.$store.commit('chatBooking/ADD_MESSAGE', message)
            } else {
              this.$swal({text: 'Error:' + response.message, type: 'error'})
            }
          })
          .catch((error) => {
            this.isSubmitting = false
            console.log(error)
          })
      },
      fetchAddressProvinces () {
        this.$store.dispatch('addressProvince/LOAD_ADDRESS_PROVINCES')
      },
      fetchDistricts (provinceId) {
        if (provinceId) {
          const queryData = {
            province_id: provinceId
          }
          this.$store.dispatch('addressProvince/LOAD_DISTRICTS', queryData)
        }
      },
      fetchSubDistricts (districtId) {
        if (districtId) {
          const queryData = {
            district_id: districtId
          }
          this.$store.dispatch('addressProvince/LOAD_SUB_DISTRICTS', queryData)
        }
      },
      clearFileUploadError (file) {
        this.errorNoUploadPhoto = false
      }
    },
    mounted () {
      this.fetchUserPlace()
      this.fetchAddressProvinces()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/ServiceRequestSecondMessage.vue